module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "signedDataEcharts"
    }
  }, [_c('div', {
    staticClass: "center-DataBox"
  }, [_c('div', {
    staticClass: "left-DataBox"
  }, [_c('div', {
    attrs: {
      "id": "lOne-box"
    }
  }, [_c('div', {
    staticClass: "BoxText"
  }, [_vm._v("项目地区")]), _vm._v(" "), _c('div', {
    staticClass: "regionData"
  }, _vm._l((_vm.ProjectAreaList.reportList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "BoxData"
    }, [_c('div', {
      staticClass: "SmBoxData"
    }, [_c('div', {
      staticClass: "region"
    }, [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "number"
    }, [_vm._v(_vm._s(_vm.AmountFormat(item.amount))), _c('i', [_vm._v("元")])]), _vm._v(" "), _c('div', {
      staticClass: "regionB"
    }, [_vm._v(_vm._s(item.count)), _c('i', [_vm._v("个")])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.screenWidth <= 1366 ? false : true),
        expression: "screenWidth <=1366 ? false : true"
      }],
      staticClass: "DataImg"
    }, [_c('img', {
      attrs: {
        "src": item.itemIcon,
        "alt": ""
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    ref: "progressBar",
    attrs: {
      "id": "progress-bar"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right-DataBox"
  }, [_c('div', {
    staticClass: "pieOneBox"
  }, [_c('div', {
    ref: "pieOne",
    attrs: {
      "id": "echartsBox"
    }
  }), _vm._v(" "), (_vm.Judge) ? _c('div', {
    staticClass: "nodata_box"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂无数据")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pieTwoBox"
  }, [_c('div', {
    ref: "pieTwo",
    attrs: {
      "id": "echarts-Box"
    }
  }), _vm._v(" "), (_vm.CooperationTypeJudge) ? _c('div', {
    staticClass: "nodata_box"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂无数据")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "pieThree",
    attrs: {
      "id": "echarts"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-DataBox"
  }, [_c('div', {
    staticClass: "dataSortBox"
  }, [_vm._m(0), _vm._v(" "), (_vm.RankingProjectAmountList.length) ? _c('div', {
    attrs: {
      "id": "dataSort"
    }
  }, [_c('div', {
    staticClass: "bottom-Data"
  }, [_c('table', {
    staticClass: "table-Box",
    staticStyle: {
      "table-layout": "fixed"
    }
  }, [_c('tr', {
    staticClass: "herader-Box"
  }, [_c('td', {
    class: {
      'tdName': _vm.screenWidth == 1920
    },
    attrs: {
      "width": _vm.screenWidth <= 1366 ? 200 : (_vm.screenWidth <= 1536 ? 380 : 530)
    }
  }, [_vm._v("项目名称")]), _vm._v(" "), _c('td', {
    staticClass: "tdMoney",
    attrs: {
      "width": _vm.screenWidth >= 1536 ? 140 : 120,
      "align": "right"
    }
  }, [_vm._v("签约金额(元)")])]), _vm._v(" "), _vm._l((_vm.RankingProjectAmountList), function(item, index) {
    return _c('tr', {
      key: index,
      attrs: {
        "height": _vm.screenWidth <= 768 ? 30 : (_vm.screenWidth <= 1366 ? 42 : 42)
      }
    }, [_c('td', [_c('div', {
      class: {
        'smallBox': _vm.screenWidth == 1920,
        'TdWidth': _vm.screenWidth == 1536,
        'dataBox': _vm.screenWidth == 1366,
      },
      staticStyle: {
        "display": "flex"
      }
    }, [(_vm.TextShow && _vm.actived == index) ? _c('span', {
      staticClass: "showTips",
      style: ({
        left: _vm.x + 'px'
      })
    }, [_vm._v(_vm._s(item.name))]) : _vm._e(), _vm._v(" "), _c('span', {
      class: {
        'red': item.serialNumber == '1',
        'orange': item.serialNumber == '2',
        'yellow': item.serialNumber == '3'
      },
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_vm._v(_vm._s(item.serialNumber))]), _vm._v(" "), _c('span', {
      staticClass: "pro_name",
      on: {
        "mouseover": function($event) {
          $event.stopPropagation();
          _vm.getText($event, item.name);
          _vm.actived = index
        },
        "mouseout": function($event) {
          $event.stopPropagation();
          _vm.TextShow = false
        }
      }
    }, [_vm._v("\n                                      " + _vm._s(item.name) + "\n                                      ")])])]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm.AmountFormat(item.amount)))])])
  })], 2)])]) : _c('div', {
    staticClass: "nodata_box"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂无数据")])])]), _vm._v(" "), _c('div', {
    staticClass: "S-dataSortBox"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "tablist"
  }, [_c('li', {
    class: {
      'active': _vm.activeProjectName === 'AMOUNT'
    },
    on: {
      "click": function($event) {
        return _vm.handleClick('AMOUNT')
      }
    }
  }, [_vm._v("签约金额")]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.activeProjectName === 'QUANTITY'
    },
    on: {
      "click": function($event) {
        return _vm.handleClick('QUANTITY')
      }
    }
  }, [_vm._v("签约数量")])]), _vm._v(" "), (_vm.DirectorRankingList.length && _vm.activeProjectName === 'AMOUNT') ? _c('div', {
    attrs: {
      "id": "S-dataSort"
    }
  }, [_c('div', {
    staticClass: "bottom-Data"
  }, [_c('table', {
    staticClass: "table-Box"
  }, [_c('tr', {
    staticClass: "herader-Box"
  }, [_c('td', {
    attrs: {
      "width": _vm.screenWidth <= 1366 ? 200 : 300
    }
  }, [_vm._v("项目总监")]), _vm._v(" "), _c('td', {
    class: {
      'show': _vm.screenWidth <= 768
    },
    attrs: {
      "width": "150",
      "align": "center"
    }
  }, [_vm._v("签约总数(个)")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "140",
      "align": "right"
    }
  }, [_vm._v("签约金额(元)")])]), _vm._v(" "), _vm._l((_vm.DirectorRankingList), function(item, index) {
    return _c('tr', {
      key: index,
      attrs: {
        "height": _vm.screenWidth <= 768 ? 30 : (_vm.screenWidth <= 1366 ? 38 : 38)
      }
    }, [_c('td', [_c('div', {
      staticClass: "dataBox"
    }, [_c('span', {
      class: {
        'red': item.serialNumber == '1',
        'orange': item.serialNumber == '2',
        'yellow': item.serialNumber == '3'
      },
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_vm._v(_vm._s(item.serialNumber))]), _vm._v(_vm._s(item.pmName) + " " + _vm._s(item.phone) + "\n                                  ")])]), _vm._v(" "), _c('td', {
      class: {
        'show': _vm.screenWidth <= 768
      },
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(item.count))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm.AmountFormat(item.amount)))])])
  })], 2)])]) : (_vm.DirectorRankingList.length && _vm.activeProjectName === 'QUANTITY') ? _c('div', {
    attrs: {
      "id": "S-dataSort"
    }
  }, [_c('div', {
    staticClass: "bottom-Data"
  }, [_c('table', {
    staticClass: "table-Box"
  }, [_c('tr', {
    staticClass: "herader-Box"
  }, [_c('td', {
    attrs: {
      "width": _vm.screenWidth <= 1366 ? 200 : 500
    }
  }, [_vm._v("项目总监")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "100",
      "align": "center"
    }
  }, [_vm._v("签约总数(个)")])]), _vm._v(" "), _vm._l((_vm.DirectorRankingList), function(item, index) {
    return _c('tr', {
      key: index,
      attrs: {
        "height": _vm.screenWidth <= 768 ? 30 : (_vm.screenWidth <= 1366 ? 38 : 38)
      }
    }, [_c('td', [_c('div', {
      staticClass: "dataBox"
    }, [_c('span', {
      class: {
        'red': item.serialNumber == '1',
        'orange': item.serialNumber == '2',
        'yellow': item.serialNumber == '3'
      },
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_vm._v(_vm._s(item.serialNumber))]), _vm._v(_vm._s(item.pmName) + " " + _vm._s(item.phone) + "\n                                  ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(item.count))])])
  })], 2)])]) : _c('div', {
    staticClass: "nodata_box"
  }, [_c('img', {
    attrs: {
      "src": "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂无数据")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-Name"
  }, [_c('i', {
    staticClass: "el-icon-s-data"
  }), _vm._v(" "), _c('p', {
    staticClass: "titleName"
  }, [_vm._v("项目签约金额排行")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-Name"
  }, [_c('i', {
    staticClass: "el-icon-s-data"
  }), _vm._v(" "), _c('p', {
    staticClass: "titleName"
  }, [_vm._v("项目总监签约排行")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b52f8ccc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportComponent/signedDataEcharts.vue
// module id = 1683
// module chunks = 471